import { createFullCollection, createManifestFromUUID } from '@src/utils/manifest-exporter';
import { collectionStore } from './collections.svelte';
import { inspectorStore } from './inspector.svelte';
import { markerStore } from './markers.svelte';
import { notificationStore } from './notification-centre.svelte';

const REFRAME = {
	collections: collectionStore,
	markers: markerStore,
	notifications: notificationStore,
	inspector: inspectorStore,
	builder: {
		createFullCollection,
		createManifestFromUUID,
	},
};

// @ts-expect-error
window.REFRAME = REFRAME;
